import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Icons } from '../common/Icons';
import toast from 'react-hot-toast';

const NAV = [
  { group: 'Overview', items: [
    { to: '/',            label: 'Dashboard',       Icon: Icons.Dashboard },
  ]},
  { group: 'Catalog', items: [
    { to: '/suppliers',   label: 'Suppliers',        Icon: Icons.Suppliers },
    { to: '/brands',      label: 'Brands',           Icon: Icons.Brands,   adminOnly: true },
    { to: '/items',       label: 'Items',            Icon: Icons.Items },
  ]},
  { group: 'Procurement', items: [
    { to: '/purchase-orders',   label: 'Purchase Orders', Icon: Icons.PO },
    { to: '/grn',               label: 'Receive Goods',   Icon: Icons.GRN },
    { to: '/purchase-returns',  label: 'Purchase Return', Icon: Icons.Return },
  ]},
  { group: 'Sales', items: [
    { to: '/invoices',      label: 'Invoices',       Icon: Icons.Invoice },
    { to: '/deliveries',    label: 'Delivery',       Icon: Icons.Delivery },
    { to: '/sales-returns', label: 'Sales Return',   Icon: Icons.Return },
  ]},
  { group: 'Settings', adminOnly: true, items: [
    { to: '/status',   label: 'Status List',   Icon: Icons.Status },
    { to: '/couriers', label: 'Courier List',  Icon: Icons.Courier },
    { to: '/colors',   label: 'Subcategory',   Icon: Icons.Color },
    { to: '/users',    label: 'Users',         Icon: Icons.Users },
  ]},
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };
  const close = () => setOpen(false);
  const initials = user?.full_name?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase() || 'U';

  return (
    <div className="app-shell">
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={close} />

      <nav className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="sidebar-brand-name">Closet by<br />Shaila Sara</div>
          <div className="sidebar-brand-sub">Management System</div>
        </div>

        {NAV.map(group => {
          if (group.adminOnly && !isAdmin) return null;
          const visibleItems = group.items.filter(item => !item.adminOnly || isAdmin);
          if (visibleItems.length === 0) return null;
          return (
            <div className="nav-section" key={group.group}>
              <div className="nav-section-label">{group.group}</div>
              {visibleItems.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                  onClick={close}
                >
                  <item.Icon size={16} />
                  {item.label}
                </NavLink>
              ))}
            </div>
          );
        })}

        <div className="sidebar-footer">
          <div className="sidebar-user-name">{user?.full_name}</div>
          <div className="sidebar-user-role">{user?.role}</div>
          <button className="btn btn-ghost btn-sm w-full"
            style={{ color: 'rgba(255,255,255,.45)', borderColor: 'rgba(255,255,255,.12)', justifyContent: 'center' }}
            onClick={handleLogout}>
            <Icons.Logout size={14} />
            Sign Out
          </button>
        </div>
      </nav>

      <div className="main-area">
        <header className="topbar">
          <div className="topbar-left">
            <button className="menu-toggle" onClick={() => setOpen(o => !o)}>
              <Icons.Menu size={20} />
            </button>
            <span className="topbar-title">Closet by Shaila Sara</span>
          </div>
          <div className="topbar-right">
            <div className="topbar-user-chip">
              <div className="topbar-avatar">{initials}</div>
              <span>{user?.full_name}</span>
            </div>
          </div>
        </header>
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
